<app-dialog-container>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <h1 mat-dialog-title>{{ title }}</h1>
    </div>
    <div>
      <button
        *ngIf="typeCes === typeCesEnum.EDIT"
        mat-icon-button
        (click)="changeType(typeCesEnum.SHOW)">
        <mat-icon class="btn-show">visibility</mat-icon>
      </button>
    </div>
  </div>
  <div>
    <app-input [config]="getFieldConfig('selectReference')" [typeCes]="typeCes"
      [group]="form" fxFlex="40"></app-input>
  </div>
  <div>
    <app-input [config]="getFieldConfig('isUnitCommission')" [typeCes]="typeCes"
      [group]="form" fxFlex="40"></app-input>
  </div>
  <div>
    <app-input [config]="getFieldConfig('isDaysCount')" [typeCes]="typeCes"
      [group]="form" fxFlex="40"></app-input>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
    <app-input *ngIf="form.get('selectReference')?.value"
      [config]="getFieldConfig('referenceValue')" [typeCes]="typeCes"
      [group]="form" fxFlex="40"></app-input>
    <app-input *ngIf="form.get('selectReference')?.value"
      [config]="getFieldConfig('percentage')" [typeCes]="typeCes" [group]="form"
      fxFlex="40"></app-input>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
    <app-input [config]="getFieldConfig('partners')" [typeCes]="typeCes"
      [group]="form" fxFlex="40"
      (onSelect)="selectPartners($event)"></app-input>
    <app-input [config]="getFieldConfig('type')" [typeCes]="typeCes"
      [group]="form" fxFlex="40"></app-input>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
    <app-input
      [config]="getFieldConfig('system')"
      [typeCes]="typeCes"
      [group]="form" fxFlex="40"></app-input>
    <app-input
      [config]="getFieldConfig('terminalQuantity')"
      [typeCes]="typeCes"
      [group]="form" fxFlex="18"></app-input>
    <app-input
      [config]="getFieldConfig('dueDate')"
      [typeCes]="typeCes"
      [group]="form"
      fxFlex="20">
    </app-input>
  </div>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
    <app-input
      [config]="getFieldConfig('monthlyValue')"
      [typeCes]="typeCes"
      [group]="form" fxFlex="40"></app-input>

    <app-input [config]="getFieldConfig('adhesionFee')" [typeCes]="typeCes"
      [group]="form" fxFlex="40"></app-input>
  </div>

  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
    <app-input [config]="getFieldConfig('planDescription')" [typeCes]="typeCes"
      [group]="form" fxFlex="83"></app-input>
  </div>

  <div fxLayout="row" fxLayoutAlign="end center">
    <button
      mat-raised-button
      color="primary"
      [disabled]="!form.valid"
      (click)="onSubmit(form.value)">
      Salvar
    </button>
  </div>
</app-dialog-container>